module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "material-table-widget dashboard_top_bar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('button', {
    staticClass: "btn btn-default btn-new",
    attrs: {
      "id": "show-modal"
    },
    on: {
      "click": function($event) {
        _vm.ActivityModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 新增待辦事項")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 form-inline text-right flex-end display-block"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.goSetting()
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-settings"
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.owner_filter),
      expression: "owner_filter"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.owner_filter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setFilterDealOwner()
      }]
    }
  }, _vm._l((_vm.company_users), function(user) {
    return _c('option', {
      domProps: {
        "value": user.value
      }
    }, [_vm._v(_vm._s(user.name))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "widget-wrap"
  }, [_c('FullCalendar', {
    ref: "fullCalendar",
    attrs: {
      "defaultView": _vm.view_type,
      "locale": _vm.locale,
      "editable": true,
      "plugins": _vm.calendarPlugins,
      "droppable": true,
      "events": _vm.activities,
      "startEditable": true,
      "header": _vm.header,
      "navLinks": true,
      "eventLimit": true,
      "selectable": true,
      "selectMirror": true
    },
    on: {
      "changeMonth": _vm.changeMonth,
      "eventClick": _vm.eventClick,
      "dateClick": _vm.dateClick,
      "moreClick": _vm.moreClick,
      "eventDrop": _vm.eventDrop,
      "eventResize": _vm.eventResize,
      "select": _vm.select,
      "viewSkeletonRender": _vm.viewSkeletonRender
    }
  })], 1)])])])]), _vm._v(" "), (_vm.ActivityModal || _vm.editModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.cancelAddActivity()
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    staticStyle: {
      "background": "none"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.cancelAddActivity()
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-7",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    attrs: {
      "name": "header text-center"
    }
  }, [(_vm.ActivityModal) ? _c('h5', [_vm._v("新增待辦事項")]) : _c('h5', [_vm._v("修改待辦事項")])]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.cancelAddActivity()
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body j-forms scroll"
  }, [_c('div', {
    staticClass: "text-left form-group"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "..."
    }
  }, _vm._l((_vm.activity_categories), function(category) {
    return _c('button', {
      staticClass: "btn btn-default",
      class: {
        active: _vm.temp_activity.activity_category_id === category.id
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.temp_activity.activity_category_id = category.id
        }
      }
    }, [_c('i', {
      class: category.icon
    }), _vm._v(" " + _vm._s(category.title))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(0), _vm._v(" "), _c('datepicker', {
    attrs: {
      "input-class": "form-control",
      "language": "zh",
      "format": 'yyyy-MM-dd'
    },
    on: {
      "selected": _vm.startDateMove
    },
    model: {
      value: (_vm.temp_activity.start_date),
      callback: function($$v) {
        _vm.temp_activity.start_date = $$v
      },
      expression: "temp_activity.start_date"
    }
  })], 1)])]), _vm._v(" "), (_vm.temp_activity.allDay == false) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "時間",
      "format": "HH:mm",
      "minute-interval": 5
    },
    model: {
      value: (_vm.temp_activity.start_time),
      callback: function($$v) {
        _vm.temp_activity.start_time = $$v
      },
      expression: "temp_activity.start_time"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.temp_activity.allDay == false) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "時間",
      "format": "HH:mm",
      "minute-interval": 5
    },
    model: {
      value: (_vm.temp_activity.end_time),
      callback: function($$v) {
        _vm.temp_activity.end_time = $$v
      },
      expression: "temp_activity.end_time"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(2), _vm._v(" "), _c('datepicker', {
    attrs: {
      "input-class": "form-control",
      "language": "zh",
      "format": 'yyyy-MM-dd'
    },
    on: {
      "selected": _vm.startDateMove
    },
    model: {
      value: (_vm.temp_activity.end_date),
      callback: function($$v) {
        _vm.temp_activity.end_date = $$v
      },
      expression: "temp_activity.end_date"
    }
  })], 1)])]), _vm._v(" "), (_vm.temp_activity.allDay == true) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.temp_activity.allDay = false
      }
    }
  }, [_vm._v("增加時間")])]) : _vm._e()]), _vm._v(" "), (_vm.temp_activity.time_warning) ? _c('p', {
    staticClass: "alert alert-warning"
  }, [_vm._v("結束時間必須在開始時間之後")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row grid-divider"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_activity.title),
      expression: "temp_activity.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "待辦事項*",
      "name": "title"
    },
    domProps: {
      "value": (_vm.temp_activity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.temp_activity.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('title')),
      expression: "errors.has('title')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('title')),
      expression: "errors.has('title')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("標題為必填\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_activity.location),
      expression: "temp_activity.location"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "地點"
    },
    domProps: {
      "value": (_vm.temp_activity.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.temp_activity.location = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "autosize",
      rawName: "v-autosize",
      value: (_vm.temp_activity.content),
      expression: "temp_activity.content"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_activity.content),
      expression: "temp_activity.content"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "placeholder": "事項備註"
    },
    domProps: {
      "value": (_vm.temp_activity.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.temp_activity.content = $event.target.value
      }
    }
  }, [_vm._v(_vm._s(_vm.temp_activity.content))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_activity.user_id),
      expression: "temp_activity.user_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.temp_activity.user_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("指派*")]), _vm._v(" "), _vm._l((_vm.company_users), function(user) {
    return _c('option', {
      domProps: {
        "value": user.value
      }
    }, [_vm._v(_vm._s(user.name))])
  })], 2)])]), _vm._v(" "), (_vm.temp_activity.contact_id == '') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(6), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_activity.deal_id),
      expression: "temp_activity.deal_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.temp_activity.deal_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("關係訂單")]), _vm._v(" "), _vm._l((_vm.deals), function(deal) {
    return _c('option', {
      domProps: {
        "value": deal.value
      }
    }, [_vm._v(_vm._s(deal.title))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.temp_activity.deal_id == '') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(7), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "url": _vm.url,
      "anchor": "name",
      "label": "",
      "param": "keyword",
      "name": "autocomplete",
      "placeholder": "關係客戶",
      "classes": {
        input: 'form-control login-frm-input contact_name',
        wrapper: 'input-wrapper'
      },
      "process": _vm.process_contact_JSON,
      "onSelect": _vm.handle_contact_Select,
      "onInput": _vm.set_contact_Value,
      "customHeaders": _vm.auth_token,
      "customParams": {
        type: 'contact'
      }
    },
    model: {
      value: (_vm.temp_activity.contact_id),
      callback: function($$v) {
        _vm.temp_activity.contact_id = $$v
      },
      expression: "temp_activity.contact_id"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "..."
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    class: {
      active: _vm.active_priority === 'low'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.temp_activity.activity_priority = 'low';
        _vm.active_priority = 'low'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flag",
    staticStyle: {
      "color": "gray"
    }
  }), _vm._v("優先度低")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    class: {
      active: _vm.active_priority === 'middle'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.temp_activity.activity_priority = 'middle';
        _vm.active_priority = 'middle'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v("優先度中")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    class: {
      active: _vm.active_priority === 'high'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.temp_activity.activity_priority = 'high';
        _vm.active_priority = 'high'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v("優先度高")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center block"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [(_vm.ActivityModal && _vm.create_loading == false) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("\n                建立\n              ")]) : _vm._e(), _vm._v(" "), (_vm.ActivityModal && _vm.create_loading == true) ? _c('button', {
    staticClass: "btn btn-primary disabled"
  }, [_vm._v("\n                建立中...\n              ")]) : _vm._e(), _vm._v(" "), (_vm.ActivityModal == false && _vm.create_loading == false) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("\n                修改\n              ")]) : _vm._e(), _vm._v(" "), (_vm.ActivityModal == false && _vm.create_loading == true) ? _c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("\n                修改中...\n              ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.cancelAddActivity()
      }
    }
  }, [_vm._v("\n                取消\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showActivityModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.showActivityModal = false;
        _vm.showActivity = ''
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    staticStyle: {
      "background": "none"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper ",
    on: {
      "click": function($event) {
        _vm.showActivityModal = false;
        _vm.showActivity = ''
      }
    }
  }, [_c('div', {
    staticClass: "modal-container modal-center col-md-4",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    attrs: {
      "name": "header text-center"
    }
  }, [_c('div', {
    staticClass: "widget-header margin-bottom-0 clearfix"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [(_vm.showActivity.activity_status == 'doing') ? _c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('標註為完成'),
      expression: "'標註為完成'"
    }],
    staticClass: "row-edit",
    on: {
      "click": function($event) {
        _vm.updateActivityStatus(_vm.showActivity, 'finish')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check text-gray"
  })]) : _c('a', {
    staticClass: "row-edit",
    on: {
      "click": function($event) {
        _vm.updateActivityStatus(_vm.showActivity, 'doing')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-check-circle text-gray text-success"
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('編輯'),
      expression: "'編輯'"
    }],
    staticClass: "row-edit",
    on: {
      "click": function($event) {
        _vm.editActivity()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pen text-gray"
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('刪除'),
      expression: "'刪除'"
    }],
    staticClass: "row-edit",
    on: {
      "click": function($event) {
        _vm.deleteActivity()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash text-gray"
  })])])])]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showActivityModal = false;
        _vm.showActivity = ''
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-left modal-body j-forms"
  }, [_c('h4', {
    staticClass: "icon-left-text"
  }, [_c('i', {
    class: _vm.showActivityIcon
  }), _vm._v(" "), _c('span', {
    class: _vm.showActivity.activity_priority + '-ball'
  }), _vm._v(_vm._s(_vm.showActivity.title) + "\n            ")]), _vm._v(" "), _c('h5', {
    staticClass: "icon-left-text"
  }, [_c('i', {
    staticClass: "far fa-clock"
  }), _vm._v(_vm._s(_vm.showActivityTime))]), _vm._v(" "), (_vm.showActivity.location) ? _c('h5', {
    staticClass: "icon-left-text"
  }, [_c('i', {
    staticClass: "fas fa-map-marker"
  }), _vm._v(_vm._s(_vm.showActivity.location))]) : _vm._e(), _vm._v(" "), (_vm.showActivity.deal.title) ? _c('h5', {
    staticClass: "icon-left-text"
  }, [_c('i', {
    staticClass: "fa fa-file-invoice-dollar"
  }), _vm._v(_vm._s(_vm.showActivity.deal.title))]) : _vm._e(), _vm._v(" "), (_vm.showActivity.contact.name) ? _c('h5', {
    staticClass: "icon-left-text"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(_vm._s(_vm.showActivity.contact.name) + " " + _vm._s(_vm.showActivity.contact.phone) + " " + _vm._s(_vm.showActivity.contact.email))]) : _vm._e(), _vm._v(" "), (_vm.showActivity.content) ? _c('h5', {
    staticClass: "icon-left-text"
  }, [_c('i', {
    staticClass: "fas fa-list"
  }), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.showActivity.content)
    }
  })]) : _vm._e()])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1"
  }, [_c('span', {
    staticStyle: {
      "line-height": "39px",
      "font-size": "20px"
    }
  }, [_vm._v("～")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fas fa-map-marker"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-invoice-dollar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-561d5033","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activities/ActivityList.vue
// module id = 690
// module chunks = 4